import { DateTime } from "luxon";

const RANDOM_SUFFIX_LENGTH = 7;

/**
 * Generates a unique id for a custom link (timestamp + random suffix).
 */
export function generateCustomLinkId(): string {
    return `custom-${DateTime.now().toMillis()}-${Math.random()
        .toString(36)
        .slice(2, 2 + RANDOM_SUFFIX_LENGTH)}`;
}
